import React from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  expelMember,
  handoverEmperor,
  openDialog,
  toggleCommander
} from "../../../store/actions";

interface IProps {
  id: number;
  memberName: string;
  commander?: boolean;
  header: string;
  elementRef: any;
}

const mapStateToProps = (state: any) => ({
  war: state.governorate.war
})

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  expelMemberDispatch: (governorateId: number) => dispatch(expelMember(governorateId)),
  toggleCommanderDispatch: (governorateId: number) => dispatch(toggleCommander(governorateId)),
  handoverEmperorDispatch: (governorateId: number) => dispatch(handoverEmperor(governorateId))
})
const connector = connect(mapStateToProps, mapDispatchToProps);

const MemberActions = ({
  id,
  memberName,
  commander,
  header,
  elementRef,
  war,
  openDialogDispatch,
  expelMemberDispatch,
  toggleCommanderDispatch,
  handoverEmperorDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <table className="table">
    <tr>
      <td className="no-border">
        <a
          onClick={() => !war && openDialogDispatch({
            name: "ConfirmDialog",
            header: "Expel from alliance",
            clear: true,
            question: `Do you want to expel ${memberName} from alliance?`,
            cancel: "Back",
            cancelAction: () => openDialogDispatch({
              name: "MemberActions",
              clear: true,
              header,
              id,
              elementRef
            }),
            confirm: "Expel",
            confirmAction: () => expelMemberDispatch(id),
            elementRef
          })}
          className={`btn btn-blank btn-no-width ${war ? "disabled" : ""}`}
        >
          Expel from alliance
        </a>
      </td>
    </tr>
    <tr>
      <td className="no-border">
        <a
          className="btn btn-blank btn-no-width"
          onClick={() => openDialogDispatch({
            name: "ConfirmDialog",
            header: `${commander ? "Remove" : "Name"} as marshal`,
            clear: true,
            question: commander ? `Do you want to remove the rank of marshal from ${memberName}?`
              : `Do you want to award ${memberName} the rank of marshal?`,
            cancel: "Back",
            cancelAction: () => openDialogDispatch({
              name: "MemberActions",
              clear: true,
              header,
              id,
              elementRef
            }),
            confirm: commander ? "Remove" : "Award",
            confirmAction: () => toggleCommanderDispatch(id),
            elementRef
          })}
        >
          {`${commander ? "Remove" : "Name"} as marshal`}
        </a>
      </td>
    </tr>
    <tr>
      <td className="no-border">
        <a
          className="btn btn-blank btn-no-width"
          onClick={() => openDialogDispatch({
            name: "ConfirmDialog",
            header: "Hand over emperor",
            clear: true,
            question: "Do you want to hand over emperor function? "
              + `Your emperor function will be removed and delegated to ${memberName}.`,
            cancel: "Back",
            cancelAction: () => openDialogDispatch({
              name: "MemberActions",
              clear: true,
              header,
              id,
              elementRef
            }),
            confirm: "Hand over",
            confirmAction: () => handoverEmperorDispatch(id),
            elementRef
          })}
        >
          Hand over emperor
        </a>
      </td>
    </tr>
  </table>
)

export default connector(MemberActions);
